import type { FC } from "react";
import { useEffect } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { getRecaptchaSiteKey, injectGoogleReCaptchaScript } from "@jti/fe-clients";

export const InsertGoogleRecaptcha: FC = () => {
  const config = useConfig();

  useEffect(() => {
    // X-RECAPTCHA-FEATURE-TOGGLE and reCaptchaEnabled are the same Builder field under two names
    const isRecaptchaEnabled = config["X-RECAPTCHA-FEATURE-TOGGLE"] === "true" || config.reCaptchaEnabled;
    const recaptchaId = getRecaptchaSiteKey(config);

    if (isRecaptchaEnabled && recaptchaId) {
      injectGoogleReCaptchaScript(recaptchaId);
    }
  }, [config]);

  return null;
};
